/**
 * @author        nico@zumper.com (Nico Rattazzi)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   nzr reducers
 */

import { account } from '@zcode-ui/account'
import { reducer as affordabilityCalculator } from '@zcode-ui/affordability-calculator/esm/module/reducers/slice'
import { appBannerReducer as appBanner } from '@zcode-ui/app-download-banner'
import { forYouReducer as forYou } from '@zcode-ui/for-you'
import { mapReducer as mainMap } from '@zcode-ui/map'
import { permanentAddressReducer } from '@zcode-ui/perm-address'
import { localLogicReducer } from '@zcode-ui/poi'
import {
  RESIDENT_QUOTES_SLICE_NAME,
  residentQuotesSlice,
  slicesEngrain,
} from '@zcode-ui/web-zumper-features'
import { GLOBAL_NAV_SLICE_NAME, globalNavSlice } from '@zcode-ui/web-zumper-global-state'
import {
  RENT_RESEARCH_DETAIL_SLICE_NAME,
  RENT_RESEARCH_HOMEPAGE_SLICE_NAME,
  rentResearchDetailSlice,
  rentResearchHomepageSlice,
} from '@zcode-ui/web-zumper-pages'
import notificationSettings from '@zcode/nr/es/shared/components/notification_settings/reducer'
import autocomplete from '@zcode/nr/es/shared/modules/autocomplete'
import similarListings from '@zcode/nr/es/shared/modules/similarListings'
import { combineReducers } from 'redux'
import { RESTORE_STATE } from '../actions/constants'
import { sliceSavedCustomMessage } from '../features/SavedCustomMessage/module/slice'
import { app } from '../modules/app/index'
import { default as blog } from '../modules/blog/index'
import { ccpaRequest } from '../modules/ccpa/reducers/index'
import { default as contextualFooter } from '../modules/contextualFooter/index'
import { default as currentSearchView } from '../modules/currentSearchView/index'
import { detail } from '../modules/detail/index'
import { faqDataRootReducer as faqData } from '../modules/faqData/index'
import { default as favoritesView } from '../modules/favoritesView/index'
import { default as filters } from '../modules/filters/index'
import { default as flaggedIds } from '../modules/flaggedIds/index'
import { geo } from '../modules/geo/index'
import { default as homepage } from '../modules/homepage/index'
import { default as messagedView } from '../modules/messagedView/index'
import { messages } from '../modules/messages'
import { modals } from '../modules/modals/index'
import { default as multifamilyTourTimePicker } from '../modules/multifamilyTourTimePicker/index'
import { default as navbar } from '../modules/navbar/index'
import { default as nearMe } from '../modules/nearMe/index'
import { poiRootReducer } from '../modules/poi/index'
import { priceChart } from '../modules/priceChart/index'
import { priceData } from '../modules/priceData/index'
import { profile } from '../modules/profile/index'
import { profileShare } from '../modules/profileShare/index'
import { ratingsAndReviewsReducer } from '../modules/ratingsAndReviews/index'
import { relatedListings } from '../modules/relatedListings/index'
import { renterQuestions } from '../modules/renterQuestions/index'
import { default as savedSearchesView } from '../modules/savedSearchesView/index'
import { default as schoolWidget } from '../modules/schoolWidget/index'
import { default as shortTermAvailability } from '../modules/shortTermAvailability/index'
import { shortTermPolicies } from '../modules/shortTermPolicies/index'
import { sitemap } from '../modules/sitemap/index'
import { stream } from '../modules/stream/index'
import { walkscoreRootReducer } from '../modules/walkscore/index'
import { default as bundle } from './bundle'
import { default as butterBar } from './butter_bar'
import { default as currentSearch } from './current_search'
import { default as localUser } from './local_user'
import { default as searchUI } from './search_ui'

const appReducer = combineReducers({
  account,
  affordabilityCalculator,
  app,
  appBanner,
  autocomplete,
  blog,
  bundle,
  butterBar,
  ccpaRequest,
  contextualFooter,
  currentSearch,
  currentSearchView,
  detail,
  [slicesEngrain.name]: slicesEngrain.reducer,
  faqData,
  favoritesView,
  filters,
  flaggedIds,
  forYou,
  geo,
  [GLOBAL_NAV_SLICE_NAME]: globalNavSlice.reducer,
  homepage,
  localUser,
  localLogic: localLogicReducer,
  mainMap,
  messagedView,
  messages,
  multifamilyTourTimePicker,
  modals,
  navbar,
  nearMe,
  notificationSettings,
  permanentAddress: permanentAddressReducer,
  poi: poiRootReducer,
  priceChart,
  priceData,
  relatedListings,
  profile,
  profileShare,
  ratingsAndReviews: ratingsAndReviewsReducer,
  renterQuestions,
  [RENT_RESEARCH_DETAIL_SLICE_NAME]: rentResearchDetailSlice.reducer,
  [RENT_RESEARCH_HOMEPAGE_SLICE_NAME]: rentResearchHomepageSlice.reducer,
  [RESIDENT_QUOTES_SLICE_NAME]: residentQuotesSlice.reducer,
  [sliceSavedCustomMessage.name]: sliceSavedCustomMessage.reducer,
  savedSearchesView,
  schoolWidget,
  searchUI,
  shortTermAvailability,
  shortTermPolicies,
  similarListings,
  sitemap,
  stream,
  walkscore: walkscoreRootReducer,
})

export const rootReducer = (state, action) => {
  if (action.type === RESTORE_STATE) {
    return action.state
  }
  return appReducer(state, action)
}
